const config = {
  serverUrl: process.env.REACT_APP_SERVER_URL || 'https://clickz.site:8443'  
};

export default config;
